import { Button, Grid } from "@mui/material";

type Props = {
  isManual: boolean;
};

export const ManualAutoButton = ({ isManual }: Props) => {
  return (
    <Grid container justifyContent="center">
      <Grid item md={12}>
        <Button
          title={isManual ? "Manual" : "Automatic"}
          variant="contained"
          color="primary"
          sx={{
            padding: "6px 8px",
            cursor: "auto",
            minWidth: "24px",
            height: "24px",
            backgroundColor: (theme) =>
              isManual ? theme.palette.primary.main : "green",
            "&:hover": {
              backgroundColor: (theme) =>
                isManual ? theme.palette.primary.dark : "#2e7d32",
            },
          }}
        >
          {isManual ? "M" : "A"}
        </Button>
      </Grid>
    </Grid>
  );
};
